import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'
import { history } from 'src/core/router'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.min.css'
import http from 'src/helper/http'
import ReminderBtn from 'src/component/RuleButton'
import Message from 'src/component/Message'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
  }

  state = {
    lang: langM.ar,
    language: null,
    userInfo:{},
    ipormac:null,
    banOrNo:false
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)
    console.log('language', language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    console.log('admin-control-user',this.props.location.query,this.props.location.query.finuid*1)
    let finuid = this.props.location.query.finduid*1 ||this.props.location.query.finuid*1
    this.setState({
      uid: uid,
      finuid
    })
    if (this.state.language == 'tr') {
      setDocumentTitle('Yönetici Kontrol Paneli')
    } else if (this.state.language == 'en') {
      setDocumentTitle('Admin control panel')
    } else if (this.state.language == 'ar') {
      setDocumentTitle('لوحة تحكم المشرف ')
    }
    // console.log(uid, 'uid')
    await this.getUserInfo(finuid)
    
  }

  // 初始化/接口请求初始化
 
  getUserInfo = async(uid)=>{
    let res = await http.post('/web/user/info', { uidDuid:uid+'' })
    console.log(res)
    if (res.code == 0) {
      this.setState({ userInfo:res.res,banOrNo:res.res.forbidtime < Math.floor(new Date().getTime()/1000) })
      
    }
  }
  toBanReset = ()=>{ //ban user
    let {language,uid,finuid} = this.state
    history.push(`/admin-control/bane-reset?uid=${uid}&finduid=${finuid}&onSetNbs=${6556}&language=${language}`)
  }

  resetUser =()=>{// reset user
    let {language,uid,finuid} = this.state
    history.push(`/admin-control/newBaneReset?uid=${uid}&finduid=${finuid}&onSetNbs=${123456}&language=${language}`)
  }

  goSeeData = ()=>{
    let {language,uid,finuid} = this.state
    history.push(`/admin-control/bane-reset-userdata?uid=${uid}&finduid=${finuid}&language=${language}`)
  }
  selectMytype = (e) => {
    this.setState({ ipormac: e.target.value * 1 })
  }

  showGoldModle = (open, close) => {
    let { lang } = this.state
    return (
      <div
        className="gold-modle"
        onClick={() => {
          
        }}
      >
        <div className="gold-modletitle">{lang.unbanConf}</div>
        <div className="gold-modle-btn">
          <div
            className="modle-cancle"
            onClick={() => {
              close()
            }}
          >
            {lang.no}
          </div>
          <div
            className="modle-confirm"
            onClick={() =>  this.banTimeandType(close)}
          >
            {lang.yes}
          </div>
        </div>
      </div>
    )
  }


  banTimeandType = async (close) => {
    let { lang, finuid, ipormac, userInfo } = this.state
    let res = await http.post('/web/user/forbid', {ftype: userInfo.forbidType, forbidts: -1,uid:finuid,})
    close()
    if (res.code == 0 ) {
      this.refs.msg.show(lang.successful)
    }else if (res.code == 9999 ) {
      this.refs.msg.show(res.msg)
    }
    await this.getUserInfo(finuid)
  }

  render() {
    let { lang, userInfo, banOrNo } = this.state
    return (
      <div className='admin-control-user'>
         <div className='user-card-admin-control-user'>
         <div className="set-user-info-admin-control-user"  >
                <div className="avatar-root">
                  <img className="avatar-img" src={userInfo.avatarurl}></img>   
                </div>
                <div className="user-info">
                  <div className="user-info-top">
                    <div className="top-text">{userInfo.nickname}</div>
                  </div>
                  <div className="user-info-top">
                    <div className="top-text">{userInfo.bio }</div>
                    
                  </div>
                  <div className="user-info-buttom">ID: {userInfo.uid}</div>
                </div>
 
              </div>
         </div>
         <div className='text-title'>{lang.userManage}</div>
         {userInfo && userInfo.forbidtime <= Math.floor(new Date().getTime()/1000) &&  <div className='ban-reset' onClick={this.toBanReset}>{lang.banText}</div>}
        
         {userInfo && !banOrNo && <ReminderBtn
          lang={this.state.lang}
          slotButtonComp={() => {
            return <div className='ban-reset' >{lang.unBanText}</div>
          }}
          slotContentComp={this.showGoldModle}
        />}
         
     {/*     <div className='data' onClick={this.goSeeData}>{lang.dataText}</div> */}
         <div className='reset' onClick={this.resetUser}>{lang.ResetText}</div>
         <Message ref="msg" desc={this.state.desc} />
         
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/admin-control/admin-control-user/index.js